import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Link } from "react-router-dom";
import { marketingListActions, editType, overviewStates, unicornCountry } from '../../store/marketingListStore';
import { popupActions } from '../../store/popupStore';
import { rightPanelStoreActions } from '../../store/rightPanelStore';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import MoreButton from "../layoutItems/moreButton";

import ExportIcon from '../../img/icons/Export';
import ZobrazitIcon from '../../img/icons/BBicons_Zobrazit';
import Retry from "../../img/icons/BBicons_MKT-Zopakovat";
import ChangeData from "../../img/icons/BBicons_MKT-Zmena_udaju";
import ChangeParameters from "../../img/icons/BBicons_MKT-Zmena_parametru";
import Remove from '../../img/icons/BBiconsOdstranit';
import Download from "../../img/icons/BBicons_Stahnout";
import PinIcon from '../../img/icons/BBicons_Pin';

const ICONS = {
    'export': ExportIcon,
    'preview': ZobrazitIcon
}

class RequestResultRow extends React.Component {
    state = {
        expanded: false,
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(this.props.redirectToConfig) && this.props.redirectToConfig !== prevProps.redirectToConfig) {
            this.props.history.push({ pathname: `/unicorn/${unicornCountry()}/configuration`, state: { requestId: this.props.redirectToConfig.requestId, configId: this.props.redirectToConfig.export } });
        }
    }

    render() {
        const r = this.props.request;
        if (isNullOrUndefined(r))
            return null;
        const reqID = `${this.props.translate("MarketingList.Common.Shortening")}${r.requestId}`;
        return (
            <tr key={`${r.requestId}`} className="ml-request">
                <td><span onClick={() => this.openPopup(r.requestId, 'detailsPopup')} className="link-functional" title={r.name ? r.state === 'Template' ? r.name : `${r.name} (${reqID})` : undefined}>
                    {r.name ? r.state === 'Template' ? this.getDisplayName(r.name, 25) : `${this.getDisplayName(r.name, 25)} (${reqID})` : reqID}</span></td>
                <td data-label={this.props.translate("Search.Cee.DateRequested")}>
                    {r.insertedFormated}
                </td>
                <td data-label={this.props.translate("MarketingList.Results.Username")}>{r.username}</td>
                <td data-label={this.props.translate("MarketingList.Results.Status")}>
                    <Translate id={`MarketingList.Status.${r.state}`} data={{ seq: r.sequenceNumber, total: r.exportPendingTotalCount }} />
                </td>
                {r.state !== 'Template' &&
                    <td className="ml-count" data-label={this.props.translate("MarketingList.Results.Count")} style={{ paddingTop: 0, paddingBottom: 0 }}>
                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <span>{r.count}</span>
                            <span style={{ width: '2.5em', marginTop: '0.1em' }}>{(r.state === "SearchCompleted" || r.state === "ReadyForRepeatExport") && r.count !== 0 && this.createButton(null, "preview",
                                () => this.onPreviewClicked(r, overviewStates), false, null, false)}</span>
                        </div>
                    </td>}
                {r.state !== 'Template' &&
                    <td className="ml-count" data-label={this.props.translate("MarketingList.Results.SubjectsToExport")} >
                        {r.subjectsToExport}
                    </td>}
                <td className="ml-button-col">
                    {(r.state === "SearchCompleted" || r.state === "ReadyForRepeatExport") && r.count !== 0 && this.createButton(this.props.translate("Search.Filter.Export"), "export",
                        () => { if (!this.exportDisabled(r.requestId)) this.openPopup(r, 'requestsPopup'); }, this.exportDisabled(r.requestId), null, !this.exportDisabled(r.requestId), this.exportDisabled(r.requestId) ? this.props.translate('MarketingList.Results.ConfirmExport') : null)}
                    {r.state === "Completed" && this.createFaButton(this.props.translate("MarketingList.Results.Button.Download"), "download", null,
                        false, this.getDownloadUrl(r.requestId), true)}
                    {r.state === "Loading" && <FontAwesomeIcon icon='cog' spin />}
                </td>
                <td data-label={this.props.translate("Common.Action")}>
                    {r.state !== 'MarkedForDelete' && <MoreButton mode={this.getMoreButtonMode()} contentWidth={250} id={`mb-${r.requestId}`}>
                        <div style={{ paddingLeft: "1em", lineHeight: "3em" }}>
                            {this.createFaButton(this.props.translate("MarketingList.Results.Button.EditParams"), "change-params",
                                undefined, !this.canEditParams(r), this.onButtonClicked(editType.searchParams, r.requestId, r.export), false, false)}
                            {this.createFaButton(this.props.translate("MarketingList.Results.Button.EditConfig"), "change-data",
                                !this.canEditConfig(r) ? () => this.props.cloneExportRequest(r.requestId) : undefined,
                                !this.canEditConfig(r), this.canEditConfig(r) ? this.onButtonClicked(editType.config, r.requestId, r.export) : undefined, false, false)}
                            {r.state !== 'Template' && this.createFaButton(this.props.translate("MarketingList.Results.Button.Retry"), "retry", () => this.props.retryExportRequest(r.requestId), !this.canRetry(r))}
                            {r.state === 'Template' && this.createFaButton(this.props.translate("MarketingList.Results.Button.Retry"), "retry", () => this.props.createRequestFromTemplate(r.requestId), !this.canRetry(r))}
                            {r.state !== 'Template' && this.createFaButton(this.props.translate("MarketingList.Results.Button.RepeatExport"), "retry", () => this.props.repeatExportRequest(r.requestId), !this.canRepeatExport(r))}
                            {r.state !== 'Template' && this.createFaButton(this.props.translate("MarketingList.Results.Button.SaveSearch"), "pin", () => this.openPopup(r.requestId, 'templatesPopup'), !this.canEditParams(r))}
                            {r.state !== 'Template' && this.createFaButton(this.props.translate("Common.Button.Remove"), 'remove', () => this.props.updateRequestStatus(r.requestId, 95), !this.canRemove(r))}
                            {r.state === 'Template' && this.createFaButton(this.props.translate("Common.Button.Remove"), 'remove', () => this.openPopup({ requestId: r.requestId, name: r.name }, 'removeTemplatePopup'), !this.canRemove(r))}
                        </div>
                    </MoreButton>}
                </td>
            </tr>
        )
    }

    getDisplayName = (name, size) => {
        return `${name.length > (size) ? `${name.slice(0, size - 1)}...` : name}`;
    }

    // Button with FontAwesome icon
    createFaButton = (caption, icon, onClick, disabled = false, href = null, color = false, download = true) => {
        return (
            <div className={`ml-link${disabled ? " disabled" : ""}${color ? " color" : ""}`} style={{ display: 'flex' }}>
                <div className="ml-link-inner center-content vertical" onClick={onClick}>
                    {this.getIcon(icon)}
                    {isNullOrUndefined(href)
                        ? <span className={`ml-link-caption${color ? " link-internal" : ""}`}>{caption}</span>
                        : <Link className={`ml-link-caption${color ? " link-internal" : ""}`} to={href} target={download ? "_blank" : undefined}>{caption}</Link>}
                </div>
            </div >
        )
    }
    getIcon(type) {
        switch (type) {
            case 'retry':
                return <Retry className="ml-link-icon" />;
            case 'change-data':
                return <ChangeData className="ml-link-icon" />;
            case 'change-params':
                return <ChangeParameters className="ml-link-icon" />;
            case 'download':
                return <Download className="ml-link-icon" />
            case 'remove':
                return <Remove className="ml-link-icon" />
            case 'pin':
                return <PinIcon className="ml-link-icon" />
            default:
                return null;
        }

    }

    // Button with BB icon
    createButton = (caption, icon, onClick, disabled = false, href = null, color = false, title = null) => {
        const Icon = ICONS[icon];
        return (
            <div className={`ml-link${disabled ? " disabled" : ""}${color ? " color" : ""}`} title={title}>
                <div className="ml-link-inner center-content vertical" onClick={onClick} style={{ display: "flex" }}>
                    {false ? <FontAwesomeIcon icon='cog' spin /> : <React.Fragment>
                        <Icon className="ml-link-icon" />
                        {isNullOrUndefined(href)
                            ? <span className={`ml-link-caption${color ? " link-internal" : ""}${disabled ? " disabled" : ""}`}>{caption}</span>
                            : <a download className="ml-link-caption link-internal" href={href}>{caption}</a>}
                    </React.Fragment>}
                </div>
            </div>
        )
    }

    onPreviewClicked = (r, overviewStatesParam) => {
        const overviewState = (this.props.overviewState === overviewStatesParam.closed ? (this.isMobile() ? overviewStatesParam.rightPanel : overviewStatesParam.overview) : this.props.overviewState)
        this.props.toggleMlOverview(overviewState, r.requestId, r.export, r.name);
        if (overviewState === overviewStatesParam.rightPanel)
            this.props.toggleRightPanel(true, 'unicorn-overview');
    }

    onButtonClicked = (type, requestId, exportId) => {
        if (isNaN(parseInt(requestId)) || isNaN(parseInt(exportId)))
            return undefined;

        switch (type) {
            case editType.searchParams:
                return `/unicorn/${unicornCountry()}/parameters?requestId=${requestId}&configId=${exportId}`;
            case editType.config:
                return `/unicorn/${unicornCountry()}/configuration?requestId=${requestId}&configId=${exportId}`;
            default:
                return undefined;
        }
    }

    openPopup = (request, type) => {
        this.props.showPopup(type, {
            open: true,
            close: () => { this.props.hidePopup() },
            data: request
        })
    }

    getButtonClass(enabled) {
        return `bb-button is-primary gradient-1 ml-btn${enabled ? "" : " disabled"}`;
    }

    canRetry(r) { return r.canRetry && r.state !== "Loading"; }
    canRepeatExport(r) { return r.canRepeatExport && r.state !== "Loading"; }
    canRemove(r) { return r.canRemove && r.state !== "Loading"; }
    canEditConfig(r) { return r.canEditExport && r.state !== "Loading"; }
    canClone(r) { return r.canClone && r.state !== "Loading"; }
    canEditParams(r) { return r.canEditSearch && r.state !== "Loading"; }

    getDownloadUrl = (id) => {
        if (isNaN(parseInt(id)))
            return undefined;

        return `/files/marketing-list/result/${id}`;
    }

    exportDisabled = (requestId) => {
        return this.props.overviewState !== overviewStates.closed && this.props.overviewRequestId === requestId;
    }

    isMobile = () => {
        return window.innerWidth <= 992;
    }

    getMoreButtonMode = () => {
        return this.isMobile() ? "leftAligned" : "rightAligned";
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.marketingList, popup: state.popup, user: state.userContext }),
    dispatch => bindActionCreators({ ...popupActions, ...marketingListActions, ...rightPanelStoreActions }, dispatch)
)(RequestResultRow)));